import { PortableTextBlock } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Container, Section } from 'components/GridV2';
import { Check } from 'components/icons';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { GetKOHOBtn } from 'components/rebrand/GetKOHOBtn';

import { IQueryParams, ISanityImgMobDesk, ITrackEventProps } from 'typescriptDefs';

interface Props {
  heading: PortableTextBlock | PortableTextBlock[];
  benefits: { heading: string; content: string }[];
  btnText: string;
  image: ISanityImgMobDesk;
  tracking: {
    queryParams: IQueryParams;
    trackEventProps: ITrackEventProps;
  };
}

const Benefits = ({ heading, benefits, btnText, image, tracking }: Props) => {
  return (
    <Section className="bg-primary-500 px-32 py-64 md:px-[unset] md:py-96">
      <Container className="grid gap-40 md:grid-cols-2 md:gap-64">
        <div>
          <div className="mb-24 text-secondary-50 [&_strong]:text-secondary-75">
            <CustomPortableText headingStyles={{ h2: { className: 'text-[32px] md:text-[42px]' } }} content={heading} />
          </div>
          <ul className="mb-32 md:mb-24">
            {benefits.map((benefit, i) => (
              <li key={i} className="grid grid-cols-[24px_1fr] gap-8 md:gap-16 [&:not(:last-of-type)]:mb-24">
                <div className="grid h-24 w-24 place-content-center pt-4 md:pt-8">
                  <Check className="scale-150 text-secondary-50 md:scale-[2] [&_path]:stroke-[1]" />
                </div>
                <p className="text-md text-white md:text-xl">
                  <span className="text-secondary-75">{benefit.heading}: </span> {benefit.content}
                </p>
              </li>
            ))}
          </ul>
          <GetKOHOBtn
            buttonVariant="primaryInverse"
            buttonLocation="cover-benefits"
            buttonClassName="w-full md:w-auto"
            queryParams={tracking.queryParams}
            trackEventProps={tracking.trackEventProps}
          >
            {btnText}
          </GetKOHOBtn>
        </div>
        <div className="flex justify-center overflow-hidden rounded-16">
          <div className="hidden md:block">
            <GatsbyImage alt={image.altText} image={image.imgDesktop.asset.gatsbyImageData} />
          </div>
          <div className="block md:hidden">
            <GatsbyImage alt={image.altText} image={image.imgMobile.asset.gatsbyImageData} />
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Benefits;
